export interface LeakItem {
  event: string;
  tag: string;
  tone: string;
  time: string;
  title: string;
  views: string;
}

export const leaks: LeakItem[] = [
  { event: "录音门", tag: "爆料", tone: "hot", time: "26分钟前", title: "同场导师候场室收音片段流出，指向改票前沟通", views: "18.2万" },
  { event: "澈咖啡", tag: "进展", tone: "mid", time: "1小时前", title: "三家加盟商晒出对公打款记录，疑云指向品牌方", views: "9.6万" },
  { event: "沈柏舟", tag: "实锤", tone: "hot", time: "2小时前", title: "合同第二页酬劳拆分表曝光，注明「线下另结」", views: "14.7万" },
  { event: "阿Ke", tag: "爆料", tone: "mid", time: "3小时前", title: "代练号IP属地与本人行程轨迹交叉吻合", views: "6.3万" },
  { event: "星光大冒险", tag: "进展", tone: "cool", time: "4小时前", title: "导演组二轮声明，称重投为「补录补位」流程", views: "8.1万" },
  { event: "老周", tag: "爆料", tone: "mid", time: "5小时前", title: "第二段录音指向导师团带节奏话术复盘", views: "5.5万" },
  { event: "录音门", tag: "进展", tone: "hot", time: "6小时前", title: "声纹鉴定预约回执流出，工作室未否认送检", views: "11.3万" },
  { event: "澈咖啡", tag: "爆料", tone: "mid", time: "7小时前", title: "员工群匿名截图：货款周转吃紧被反复提及", views: "7.9万" },
];

export interface ResponseItem {
  speaker: string;
  role: string;
  time: string;
  quote: string;
  status: string;
  tone: string;
}

export const responses: ResponseItem[] = [
  {
    speaker: "顾言川工作室",
    role: "当事人方",
    time: "09-05 06:40",
    quote: "部分花絮画面被断章取义、脱离语境，我们正就证据保全与名誉维权做统一部署。",
    status: "二更声明",
    tone: "defend",
  },
  {
    speaker: "选秀节目组官微",
    role: "出品方",
    time: "09-05 00:12",
    quote: "相关音频系内部未经授权翻录，存在明显拼接痕迹，已委托第三方机构开展技术鉴定。",
    status: "否认拼接",
    tone: "deny",
  },
  {
    speaker: "导师方经纪人",
    role: "导师方",
    time: "09-04 22:30",
    quote: "导师当天一切按节目流程出票，所谓「改票」纯属无端联想，将配合节目组说明。",
    status: "澄清",
    tone: "deny",
  },
  {
    speaker: "原经纪人 · 匿名投稿",
    role: "爆料方",
    time: "09-04 19:05",
    quote: "稿本改了两遍，第一版偏向群像，第二版被要求把矛头对准垫底选手，我留了底。",
    status: "再爆料",
    tone: "hot",
  },
];

export interface CommentItem {
  user: string;
  tag: string;
  vote: number;
  text: string;
  like: boolean;
  agree: string;
}

export const comments: CommentItem[] = [
  { user: "铁锅炖大鹅", tag: "实锤党", vote: 3211, text: "导师那一声「等等」太关键了，跟成片完全接不上，母带必须放出来验。", like: false, agree: "赞同 3211" },
  { user: "考拉不上树", tag: "反方", vote: 1860, text: "音频剪辑鉴定都没出就开始定性，急着定罪的跟当年冤枉人的没两样。", like: false, agree: "赞同 1860" },
  { user: "星野迷妹今天也清醒", tag: "中立吃瓜", vote: 1427, text: "看完全程只心疼选手，镜头多不一定好，被拿来当话题工具人才是真的惨。", like: false, agree: "赞同 1427" },
  { user: "现场观众阿飞", tag: "现场党", vote: 1094, text: "我就在B区第二排，中场清场确实有，返场后气氛明显不对，蹲一个完整录像。", like: false, agree: "赞同 1094" },
];

export const heatWords: string[] = [
  "声纹鉴定",
  "清场重投",
  "两版稿本",
  "导师改票",
  "站姿复盘",
  "垫底剧本",
  "二更声明",
];

export interface TopicCard {
  code: string;
  title: string;
  brief: string;
  status: string;
  statusTone: string;
  progress: number;
  hot: string;
  updates: string;
  tags: string[];
  featured?: boolean;
}

export const topics: TopicCard[] = [
  {
    code: "T01",
    title: "选秀导师改票「录音门」",
    brief: "三段现场音频流出后，节目组、导师方与原经纪人三方口径打架，编辑部全程按证据链复盘。",
    status: "持续发酵",
    statusTone: "hot",
    progress: 78,
    hot: "186.3万",
    updates: "今日 +5",
    tags: ["音频鉴定", "二更声明", "清场重投"],
    featured: true,
  },
  {
    code: "T02",
    title: "澈咖啡加盟商账目风波",
    brief: "主理人直播否认吞货款，加盟商晒对公记录对线。",
    status: "对线中",
    statusTone: "mid",
    progress: 56,
    hot: "142.7万",
    updates: "今日 +3",
    tags: ["账目", "联合声明"],
  },
  {
    code: "T03",
    title: "顶流演员「阴阳条款」",
    brief: "片约盖章页流出，被指片酬线下另结。",
    status: "第二轮爆料",
    statusTone: "mid",
    progress: 49,
    hot: "121.5万",
    updates: "今日 +2",
    tags: ["片约", "税务疑云"],
  },
  {
    code: "T04",
    title: "综艺「恶意剪辑」争议",
    brief: "导演组两轮声明难平众议，现场复盘持续。",
    status: "热中趋稳",
    statusTone: "cool",
    progress: 41,
    hot: "87.3万",
    updates: "今日 +2",
    tags: ["成片对照", "现场复盘"],
  },
  {
    code: "T05",
    title: "电竞选手代练实锤",
    brief: "代练号战绩与行程轨迹被交叉验证。",
    status: "官方沉默",
    statusTone: "cool",
    progress: 33,
    hot: "79.8万",
    updates: "今日 +1",
    tags: ["代练", "禁赛传闻"],
  },
  {
    code: "T06",
    title: "制作人改票动机链条",
    brief: "第二段录音指向导师团带节奏复盘。",
    status: "待官方回应",
    statusTone: "mid",
    progress: 27,
    hot: "52.7万",
    updates: "今日 +1",
    tags: ["录音", "动机复盘"],
  },
];